/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { createUndefinedInvestment } from "../../actions/undefinedRate";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";

import toast from "react-hot-toast";
import { nextInvestmentNumber } from "../../utils/investmentCode";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "25px",
  transform: "translate(-50%, -50%)",
  width: 700,
  // height: 500,
  bgcolor: "white",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  { id: "investment_type", label: "Investment type", minWidth: 200 },
  {
    id: "regulator",
    label: "Regulator",
    minWidth: 170,
    align: "right",
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "rate",
    label: "Rate",
    minWidth: 170,
    align: "right",
  },
  {
    id: "year_days",
    label: "Year days",
    minWidth: 170,
    align: "right",
  },
  {
    id: "purchase_date",
    label: "Purchase date",
    minWidth: 170,
    align: "right",
  },
  {
    id: "maturity_date",
    label: "Maturity date",
    minWidth: 170,
    align: "right",
  },
];
function createData(
  id,
  code,
  investment_type,
  regulator,
  cost,
  rate,
  year_days,
  purchase_date,
  maturity_date,
) {
  return {
    id,
    code,
    investment_type,
    regulator,
    cost,
    rate,
    year_days,
    purchase_date,
    maturity_date,
  };
}
export default function UndefinedInvest() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleOpen1 = () => setOpen1(true);
  const handleClose = () => setOpen(false);
  const handleClose1 = () => setOpen1(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const investmentTypes = useSelector((state) => state.investmentTypes);
  const regulators = useSelector((state) => state.regulators);
  const investments = useSelector((state) => state.undefinedRate);
  const investmentsArrayWithHighestDate = investments.reduce(
    (results, item) => {
      const {
        code,
        _id,
        date,
        total_interest,
        purchase_date,
        period_interest,
        certificate_number,
        charges,
        cost,
        daily_interest,
        impaired,
        impaired_amount,
        institution,
        investment_type,
        maturity_date,
        rate,
        rate_type,
        regulator,
        tenure,
        year_days,
        uploaded_by,
        matured_investment,
      } = item;

      if (!results[code] || moment(date) > moment(results[code].date)) {
        results[code] = {
          code,
          _id,
          date,
          total_interest,
          purchase_date,
          period_interest,
          certificate_number,
          charges,
          cost,
          daily_interest,
          impaired,
          impaired_amount,
          institution,
          investment_type,
          maturity_date,
          rate,
          rate_type,
          regulator,
          tenure,
          year_days,
          uploaded_by,
          matured_investment,
        };
      }

      return results;
    },
    {},
  );
  const datesArray = Object.values(investmentsArrayWithHighestDate);
  const [newCode, setCode] = React.useState("");

  const [notChangedState, setNotChangedState] = React.useState({});
  let [updateData, setUpdateData] = React.useState({});
  React.useEffect(() => {
    const filteredData = datesArray.filter((data) => data.code === newCode);
    if (filteredData.length > 0) {
      setUpdateData(filteredData[0]);
      setNotChangedState(filteredData[0]);
    } else {
      setUpdateData({});
      setNotChangedState({});
    }
  }, [newCode]);

  updateData.total_interest =
    notChangedState.total_interest * 1 + updateData.period_interest * 1;
  const nextNumber = nextInvestmentNumber(investments);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  let [investmentData, setInvestmentData] = React.useState({
    cost: "",
    date: "",
    rate: 0,
    purchase_date: "",
    maturity_date: "",
    year_days: "",
    charges: 0,
    investment_type: "",
    institution: "",
    regulator: "",
    certificate_number: "",
    code: "",
    uploaded_by: user.results.firstName + " " + user.results.lastName,
    tenure: "",
    daily_interest: "",
    total_interest: "",
    rate_type: "undefined rate",
    matured_investment: "false",
  });

  // No purchase date yet means no maturity date, not "Invalid date"
  investmentData.maturity_date = investmentData.purchase_date
    ? moment(investmentData.purchase_date)
        .add(Number(investmentData.tenure) || 0, "days")
        .format("YYYY-MM-DD")
    : "";

  // A regulator or type deleted since the form opened has no code
  const regCode =
    regulators.find((data) => data.regulator === investmentData.regulator)
      ?.code || "";
  const instCode =
    investmentTypes.find(
      (data) => data.investment_type === investmentData.investment_type,
    )?.code || "";
  const investmentCode = `AARB/UR/${regCode}/${instCode}/${new Date(
    investmentData.purchase_date,
  ).getFullYear()}/${nextNumber}`;

  investmentData.code = investmentCode;
  investmentData.date = investmentData.purchase_date;
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const dispatch = useDispatch();
  const [saving, setSaving] = React.useState(false);
  async function sendData() {
    if (!(
      investmentData.cost &&
      investmentData.purchase_date &&
      investmentData.year_days &&
      investmentData.investment_type &&
      investmentData.institution &&
      investmentData.regulator
    )) {
      toast.error("Please fill in all required fields");
      return;
    }
    if (!regCode || !instCode) {
      toast.error(
        "The selected regulator or investment type no longer exists. Pick it again.",
      );
      return;
    }
    setSaving(true);
    try {
      await dispatch(createUndefinedInvestment(investmentData));
      handleClose();
      setInvestmentData((prev) => ({
        ...prev,
        cost: "",
        date: "",
        rate: 0,
        purchase_date: "",
        year_days: "",
        charges: 0,
        investment_type: "",
        institution: "",
        regulator: "",
        certificate_number: "",
        tenure: "",
      }));
    } catch {
      // the action has already shown the error
    } finally {
      setSaving(false);
    }
  }
  async function sendUpdateData() {
    if (!newCode) {
      toast.error("Please select investment code");
      return;
    }
    const { _id, ...neededData } = updateData;
    setSaving(true);
    try {
      await dispatch(createUndefinedInvestment(neededData));
      handleClose1();
    } catch {
      // the action has already shown the error
    } finally {
      setSaving(false);
    }
  }

  const rows = investments.map((data) =>
    createData(
      data._id,
      data.code,
      data.investment_type,
      data.regulator,
      data.cost,
      data.rate,
      data.year_days,
      moment(data.purchase_date).format("DD-MM-YYYY"),
      moment(data.maturity_date).format("DD-MM-YYYY"),
    ),
  );

  let allowManipulate = false;
  if (
    user.results.portfolio_manager === "Administrator" ||
    user.results.portfolio_manager === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }
  const handleChangeCheck = (event) => {
    let isChecked = event.target.checked;
    setInvestmentData({ ...investmentData, matured_investment: isChecked });
  };
  return (
    <div>
      <Paper sx={{ width: "100%" }}>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id="transition-modal-title"
                variant="h5"
                component="h2"
                style={{ marginBottom: "15px" }}
              >
                Add Undefined Rate Investment
              </Typography>
              <form
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  justifyContent: "space-around",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    label="cost"
                    required
                    value={investmentData.cost}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        cost: e.target.value,
                      })
                    }
                  />

                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="date"
                    size="small"
                    label="purchase Date"
                    value={investmentData.purchase_date}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        purchase_date: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="date"
                    size="small"
                    label="Maturity date"
                    disabled
                    value={investmentData.maturity_date}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        maturity_date: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="text"
                    size="small"
                    label="Tenure"
                    value={investmentData.tenure}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        tenure: e.target.value,
                      })
                    }
                    required
                  />
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Year days
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.year_days}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          year_days: e.target.value,
                        })
                      }
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={364}>364</MenuItem>
                      <MenuItem value={365}>365</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        onChange={handleChangeCheck}
                        name="matured_investment"
                      />
                    }
                    label="Matured investment?"
                    labelPlacement="start"
                  />
                  {investmentData.matured_investment === true ? (
                    <em style={{ fontSize: "12px" }}>
                      We recommend you enter
                      <br /> higher tenure for matured
                      <br /> investment as to you don't know when <br />
                      it will be fully paid.
                      <br />
                      You can update it later
                    </em>
                  ) : (
                    ""
                  )}
                  <div>
                    <Button
                      onClick={sendData}
                      disabled={saving}
                      variant="contained"
                      size="small"
                      style={{
                        textTransform: "none",
                        margin: "5px",
                        backgroundColor: "#333D51",
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                      }}
                      onClick={handleClose}
                      size="small"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Investment type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.investment_type}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          investment_type: e.target.value,
                        })
                      }
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {investmentTypes.map((data) => (
                        <MenuItem key={data._id} value={data.investment_type}>
                          {data.investment_type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="text"
                    size="small"
                    label="Institution"
                    value={investmentData.institution}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        institution: e.target.value,
                      })
                    }
                    required
                  />
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Regulator
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.regulator}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          regulator: e.target.value,
                        })
                      }
                      label="Age"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {regulators.map((data) => (
                        <MenuItem key={data._id} value={data.regulator}>
                          {data.regulator}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="Certificate number"
                    value={investmentData.certificate_number}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        certificate_number: e.target.value,
                      })
                    }
                  />
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open1}
          onClose={handleClose1}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open1}>
            <Box sx={style}>
              <Typography
                id="transition-modal-title"
                variant="h5"
                component="h2"
                style={{ marginBottom: "15px" }}
              >
                Update Undefined Rate Investment
              </Typography>
              <form
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  justifyContent: "space-around",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      code
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={newCode}
                      onChange={(e) => setCode(e.target.value)}
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {datesArray.map((data) => (
                        <MenuItem key={data.code} value={data.code}>
                          {data.code}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    disabled={newCode ? false : true}
                    label="Interest/amount for the period"
                    required
                    value={updateData.period_interest}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        period_interest: e.target.value,
                      })
                    }
                  />

                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="date"
                    size="small"
                    disabled={newCode ? false : true}
                    label="Date"
                    value={updateData.date}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        date: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />

                  <div>
                    <Button
                      onClick={sendUpdateData}
                      disabled={saving}
                      variant="contained"
                      size="small"
                      style={{
                        textTransform: "none",
                        margin: "5px",
                        backgroundColor: "#333D51",
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                      }}
                      onClick={handleClose1}
                      size="small"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            size="small"
            disabled={!allowManipulate}
            style={{
              textTransform: "capitalize",
              margin: "5px",
            }}
            onClick={handleOpen}
            variant="contained"
          >
            Add Investment
          </Button>
          <Button
            size="small"
            disabled={!allowManipulate}
            style={{
              textTransform: "capitalize",
              margin: "5px",
            }}
            onClick={handleOpen1}
            variant="contained"
          >
            Update Investment
          </Button>
        </div>
        <em style={{ color: "red" }}>
          {allowManipulate ? "" : "you don't have the permission to add asset"}
        </em>
        <TableContainer sx={{ maxHeight: 740 }}>
          <Table size="small" stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#f8f8f8",
                      color: "#000",
                      fontWeight: "bold",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
